import React from 'react';
import ReactTable from 'react-table';
import RomanianPackage from '../languages/RomanianPackage';
import HeaderHide from '../tableHeaderExceptions/TableHeaderHide';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getSubTable} from '../actionCreators/getSubTable';
import SubFormBuilder from '../formBuilder/SubFormBuilder';
import CellBuilder from './CellBuilder';

import 'react-table/react-table.css';
import './SubComponentBuilder.css';

class SubComponent extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            phpFile: this.props.view.phpSubtype + this.props.rowData
        }
    }

    componentDidMount () {

        this.props.getSubTable(this.state.phpFile);

    }

    renderColumns(columns){

        var cols = columns.map(col => ({
            'Header': col.Name, 
            'accessor': col.Name,
            'type': col.Type,
            'editable': col.Editable,
            show: HeaderHide.includes(col.Name) ? false: true,
            Cell: (cellInfo) => {
                return (
                    <CellBuilder
                        column = {cellInfo.column.id}
                        index = {cellInfo.index}
                        data = {this.props.subData}
                        phpFile = {this.state.phpFile}
                        type = {cellInfo.column.type}
                        editable = {cellInfo.column.editable}
                        isSubComponent = {true}
                    />
                );
            }
        }));
        return (cols);
    }

    render () {

        if(this.props.subCount > 0) {
            return (
                <div>
                    <ReactTable
                        data = {this.props.subData}
                        columns = {
                            this.renderColumns(this.props.subColumns)
                        }
                        showPaginationBottom = {false}
                        pageSize={this.props.subCount}
                        className = "subTable"
                        previousText= {RomanianPackage.PREVIOUS_TEXT}
                        nextText= {RomanianPackage.NEXT_TEXT}
                        loadingText= {RomanianPackage.LOADING_TEXT}
                        noDataText= {RomanianPackage.NO_DATA_TEXT}
                        pageText= {RomanianPackage.PAGE_TEXT}
                        ofText= {RomanianPackage.OF_TEXT}
                        rowsText= {RomanianPackage.ROWS_TEXT}
                        
                    />
                    <SubFormBuilder rowId = {this.props.rowData} />
                </div>
            )
        }
        else if (this.props.view.subFormLabels) {
            return (
                <SubFormBuilder rowId = {this.props.rowData} />
            )
        }
        else return <div>{RomanianPackage.NO_DATA_TEXT}</div>
        
    }
}

function mapStateToProps(state) {
    return {
        subColumns: state.activeOption.subTableHeader,
        subData: state.subTable.subData,
        subCount: state.subTable.subCount,
        view: state.activeOption
    }
}

function matchDispatchToProps(dispatch) {

    return bindActionCreators({
        getSubTable: getSubTable
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SubComponent);


// WEBPACK FOOTER //
// ./src/tableBuilder/SubComponentBuilder.js